import axios from "axios";
import config from "configSite";
import { eBus } from "utils/eventbus";
import { getToken } from "utils/auth";

export default class AxiosInterceptor {
  constructor(baseUrl) {
    this.baseUrl = baseUrl || config.apiUrl;
    return this.init();
  }

  init() {
    let myAxios = axios.create({
      baseURL: this.baseUrl
    });
    myAxios.interceptors.request.use(
      config => {
        const token = getToken();
        config.headers.common["Authorization"] = "Bearer " + token;
        return config;
      },
      error => {
        Promise.reject(error);
      }
    );
    myAxios.interceptors.response.use(
      response => {
        return response;
      },
      function(error) {
        if (
          error.response &&
          Object.prototype.hasOwnProperty.call(error.response, "status") &&
          error.response.status === 401
        ) {
          eBus.$emit("unauthorized");
        } else if (
          error.response &&
          Object.prototype.hasOwnProperty.call(error.response, "status") &&
          error.response.status === 403
        ) {
          eBus.$emit(
            "403",
            error.response.data ? error.response.data.error.message : null
          );
          return Promise.reject("");
        }

        return Promise.reject(error);
      }
    );
    return myAxios;
  }
}
